<div class="video_wrap">
    <div [id]="'vimeo_player_'+index" #video></div>
    <div class="placeholder" (click)="playVideo()" [class.close-placeholder]="closePlaceholder">
        <!-- <img class="placeholder_image" alt="Placeholder image" [src]="placeholder"> -->
    </div>
</div>
<div class="title_n_duration" *ngIf="isMetadataVisible">
    <div class="title">{{title}}</div>
    <div class="duration">{{duration}}</div>
</div>